<template>
  <input type="text" readonly class="form-control-plaintext" :value="value">
</template>

<script>
export default {
  name: "ReadOnlyInput",
  props: {
    value: {
      type: [String, Number, null],
      required: true
    }
  }
}
</script>

<style scoped>
input:read-only {
  outline: none;
}
</style>
